import React from 'react'
import EditProfilePage from '../../component/profile/EdirProfileSection'


function EditProfile() {
  return (
    <div className='page-body'>
      <EditProfilePage/>
    </div>
  )
}

export default EditProfile
